// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__dD3zG","title":"card_title__3fFZC","inActive":"card_inActive__2Bnti"};